import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

const TermsOfService = () => {
    return (
        <LegalPageLayout>
            <div className="legal-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            {/* Breadcrumb */}
                            <nav aria-label="breadcrumb" className="mt-4">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Terms of Service
                                    </li>
                                </ol>
                            </nav>

                            {/* Page Header */}
                            <div className="text-center mb-5">
                                <h1 className="h2 font-weight-bold">Terms of Service</h1>
                                <p className="lead text-muted">Last updated: {new Date().toLocaleDateString()}</p>
                            </div>

                            {/* Content */}
                            <div className="legal-content">
                                <section className="mb-5">
                                    <h2>1. Acceptance of Terms</h2>
                                    <p>
                                        By accessing and using SalesPinch ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>2. Description of Service</h2>
                                    <p>
                                        SalesPinch is a lead management platform that provides tools for capturing, managing, and converting leads. The Service includes web and mobile applications, API access, and related services designed to help sales teams work more efficiently.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>3. User Accounts</h2>
                                    <p>
                                        To access certain features of the Service, you must create an account. You are responsible for:
                                    </p>
                                    <ul>
                                        <li>Maintaining the confidentiality of your account credentials</li>
                                        <li>All activities that occur under your account</li>
                                        <li>Providing accurate and complete information</li>
                                        <li>Notifying us immediately of any unauthorized use</li>
                                    </ul>
                                </section>

                                <section className="mb-5">
                                    <h2>4. Acceptable Use</h2>
                                    <p>You agree not to use the Service to:</p>
                                    <ul>
                                        <li>Violate any applicable laws or regulations</li>
                                        <li>Infringe upon the rights of others</li>
                                        <li>Transmit harmful, offensive, or inappropriate content</li>
                                        <li>Attempt to gain unauthorized access to the Service</li>
                                        <li>Interfere with or disrupt the Service</li>
                                        <li>Use the Service for spam or unsolicited communications</li>
                                    </ul>
                                </section>

                                <section className="mb-5">
                                    <h2>5. Data and Privacy</h2>
                                    <p>
                                        Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service, to understand our practices regarding the collection and use of your information.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>6. Intellectual Property</h2>
                                    <p>
                                        The Service and its original content, features, and functionality are and will remain the exclusive property of SalesPinch and its licensors. The Service is protected by copyright, trademark, and other laws.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>7. Subscription and Payment</h2>
                                    <p>
                                        Some features of the Service require a paid subscription. By subscribing, you agree to pay all fees associated with your chosen plan. Fees are billed in advance and are non-refundable except as required by law.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>8. Termination</h2>
                                    <p>
                                        We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>9. Limitation of Liability</h2>
                                    <p>
                                        In no event shall SalesPinch, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Service.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>10. Disclaimer</h2>
                                    <p>
                                        The information on this Service is provided on an "as is" basis. To the fullest extent permitted by law, this Company excludes all representations, warranties, conditions and terms whether express or implied.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>11. Governing Law</h2>
                                    <p>
                                        These Terms shall be interpreted and governed by the laws of the jurisdiction in which SalesPinch operates, without regard to its conflict of law provisions.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>12. Changes to Terms</h2>
                                    <p>
                                        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>13. Contact Information</h2>
                                    <p>
                                        If you have any questions about these Terms of Service, please contact us at:
                                    </p>
                                    <div className="contact-info">
                                        <p><strong>Email:</strong> legal@salespinch.com</p>
                                        <p><strong>Address:</strong> 123 Business Street, Suite 100, City, State 12345</p>
                                    </div>
                                </section>
                            </div>

                            {/* Footer Links */}
                            <div className="text-center mt-5 pt-4 border-top">
                                <div className="row">
                                    <div className="col-md-3">
                                        <Link to="/privacy" className="text-decoration-none">
                                            Privacy Policy
                                        </Link>
                                    </div>
                                    <div className="col-md-3">
                                        <Link to="/disclaimer" className="text-decoration-none">
                                            Disclaimer
                                        </Link>
                                    </div>
                                    <div className="col-md-3">
                                        <Link to="/data-deletion-policy" className="text-decoration-none">
                                            Data Deletion
                                        </Link>
                                    </div>
                                    <div className="col-md-3">
                                        <Link to="/contact" className="text-decoration-none">
                                            Contact Us
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LegalPageLayout>
    );
};

export default TermsOfService; 